import { IFormContact } from './IFormContactBlock'

export interface IBlockList {
  readonly title: string
  readonly list: ReadonlyArray<IFormContact>
  readonly isExtended: boolean
  readonly coverEagle?: string
  readonly isListItems: boolean
}

export const emptyBlockList = (): IBlockList => {
  return {
    title: '',
    list: [],
    isExtended: false,
    coverEagle: '',
    isListItems: false,
  }
}

export interface InstructionTestList {
  readonly list: ReadonlyArray<any>
  readonly answers?: ReadonlyArray<any>
}
